// =================================================================
// =================================================================
export const grey = {
  900: "#2B3445",
  // Main Text
  800: "#373F50",
  // Paragraph
  700: "#4B566B",
  600: "#576375",
  // Body / secondary text (was #7D879C; darkened for WCAG AA on white)
  500: "#6B7380",
  400: "#DAE1E7",
  // Border
  300: "#E3E9EF",
  200: "#F3F5F9",
  // Line Stroke
  100: "#F6F9FC",
};

// GREEN TONE PRIMARY (darker greens for WCAG AA vs white / vs white bg)
export const primary = {
  50: "#D9ECD2",
  100: "#E7F9ED",
  150: "#D9FCE3",
  200: "#C2F1D1",
  300: "#7AD89E",
  400: "#1FA65E",
  500: "#007A48",
  600: "#006B3D",
  700: "#005C34",
  800: "#004D2C",
  900: "#0B7724",
  main: "#007A48",
  contrastText: "#FFFFFF",
};

//yellow
export const yellow = {
  50: "#ffc640",
  100: "#ffc640",
  150: "#ffc640",
  200: "#ffc640",
  300: "#ffc640",
  400: "#ffc640",
  500: "#ffc640",
  600: "#ffc640",
  700: "#ffc640",
  800: "#ffc640",
  900: "#ffc640",
  main: "rgb(255, 198, 64)",
  contrastText: "#FFFFFF",
};

// RED TONE PRIMARY:
// export const primary = {
//   50: "#FEF2F2",
//   100: "#FCE9EC",
//   150: "#EFD8D4",
//   200: "#F8C7CF",
//   300: "#F07D90",
//   400: "#EC6178",
//   500: "#D23F57",
//   600: "#E63E58",
//   700: "#E3364E",
//   800: "#DF2E44",
//   900: "#D91F33",
// };
export const secondary = {
  100: "#e8e8ee",
  200: "#b9bacb",
  300: "#8a8ca8",
  400: "#5b5d85",
  500: "#141850",
  600: "#0F3460",
  700: "#101340",
  800: "#0e1138",
  900: "#0c0e30",
  main: "#0F3460",
  dark: "#0c0e30",
};
export const error = {
  50: "#FEF2F2",
  100: "#FFEAEA",
  200: "#FFCBCB",
  300: "#FFA9A9",
  400: "#FF6D6D",
  500: "#FF5353",
  600: "#FF4C4C",
  700: "#FF4242",
  800: "#FF3939",
  900: "#FF2929",
  main: "#E94560",
};
export const success = {
  50: "#D9ECD2",
  100: "#E7F9ED",
  200: "#C2F1D1",
  300: "#7AD89E",
  400: "#1FA65E",
  500: "#007A48",
  600: "#006B3D",
  700: "#005C34",
  800: "#004D2C",
  900: "#0b7724",
  main: "#007A48",
};
export const blue = {
  50: "#E7EFFE",
  100: "#DBF0FE",
  200: "#B8DEFE",
  300: "#94C9FE",
  400: "#7AB6FD",
  500: "#4E97FD",
  600: "#3975D9",
  700: "#2756B6",
  800: "#183C92",
  900: "#0E2979",
  main: "#4E97FD",
  contrastText: "#FFFFFF",
};
export const marron = {
  50: "#f3f5f9",
  100: "#F6F2ED",
  200: "#F8DBD1",
  300: "#EBBCB3",
  400: "#D89C98",
  500: "#C48486",
  600: "#A3545C",
  700: "#883948",
  800: "#6E2438",
  900: "#5B162F",
  main: "#BE7374",
  contrastText: "#FFFFFF",
};
export const paste = {
  50: "#F2F2F5",
  100: "#DDFBF1",
  200: "#BDF7E8",
  300: "#97E8DA",
  400: "#76D2CA",
  600: "#36929A",
  700: "#257181",
  800: "#175368",
  900: "#0E3D56",
  main: "#4BB4B4",
  contrastText: "#FFFFFF",
};
export const warning = {
  50: "#FCF8EC",
  100: "#FFF8E5",
  150: "#FDF2E2",
  300: "#F6D58F",
  900: "#F3731A",
  main: "#FFCD4E",
  contrastText: "#FFFFFF",
};
export const dark = {
  dark0: "#1C1C28",
  dark3: "#8F90A6",
  main: "#222",
};
export const light = {
  light: "#FFFFFF",
  light0: "#E4E4EB",
  light1: "#EBEBF0",
  light2: "#F2F2F5",
  main: "#E4E4EB",
};
export const white = {
  main: "#fff",
};
export const custom = {
  orange: "#F3731A",
  coral: "#FF5C5C",
};
export const themeColors = {
  dark,
  light,
  grey,
  paste,
  error,
  marron,
  warning,
  success,
  secondary,
  info: blue,
  custom,
  divider: grey[200],
  background: {
    default: "#FFFFFF",
  },
  text: {
    primary: grey[900],
    secondary: grey[800],
    disabled: grey[400],
  },
};
